import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'

import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'reader-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const columns = [
  {
    title: 'Client Id',
    dataIndex: 'clientId',
    sorter: (a, b) => a.clientId.localeCompare(b.clientId)
  },
  {
    title: 'Site Id',
    dataIndex: 'siteId',
    sorter: (a, b) => a.siteId.localeCompare(b.siteId)
  },
  {
    title: 'Reader SN',
    dataIndex: 'readerSn',
    render: (name, row) => (
      <Link to={ROUTES.READER_EDIT.replace(':siteId', row.siteId).replace(':targetClientId', row.clientId).replace(':readerSn', row.readerSn)}>
        {name}
      </Link>
    ),
    sorter: (a, b) => a.readerSn.localeCompare(b.readerSn)
  },
  {
    title: 'Agent Id',
    dataIndex: 'agentId',
    sorter: (a, b) => a.agentId.localeCompare(b.agentId)
  },
  {
    title: 'Endpoint',
    dataIndex: 'endpoint',
    sorter: (a, b) => a.endpoint.localeCompare(b.endpoint)
  }
]

const ListViewReaders = ({ readers }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {readers.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {readers.length} readers
      </PageContentUnderTitle>
    )}
    <Table dataSource={readers} columns={columns} pagination={false} rowKey="readerId" />
  </div>
)

export default ListViewReaders



// WEBPACK FOOTER //
// ./src/pages/summary/summary-list/components/list-view-readers/index.js